import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

function RoleModal(props) {
    return (
        <ModalBasic
            id="add-role-modal"
            modalOpen={props.addRoleModalOpen}
            setModalOpen={props.setAddRoleModalOpen}
            classParams="!w-[40%] p-5"
        >
            <span className="text-blue text-[16px] font-semibold">Role Details</span>
            <div className='input-grp w-full mt-5'>
                <label>Role</label>
                <TextInput
                    type='text'
                    id='roleName' name='roleName'
                    value={props.roleObject.roleName}
                    handleChange={(event) => props.handleChange(event, 'roleName')}
                    className={props.validState?.error?.roleName !== undefined ? "error" : ""}
                />
            </div>
            <div className='input-grp w-full mt-5'>
                <label>Role Category</label>
                {/* <textarea
                    rows={4}
                    id='description'
                    name='description'
                    value={props.roleObject.description}
                    onChange={(event) => props.handleChange(event, 'description')}
                    className={props.validState?.error?.role ? "error" : ""}
                /> */}
                <MultiSelectDropdown
                    //className={props.validState?.error?.idEmployeeSalary !== undefined ? "error" : ""}
                    options={props.roleCategoryList}
                    //value={props.employeeBasicDetails.idEmployeeSalary}
                    value={props.roleObject.roleCategoryId ? props.roleCategoryList?.find(x => x.value === props.roleObject.roleCategoryId) : 0}
                    onChange={(event) =>
                        props.handleChange(
                            event, "roleCategoryId"
                        )
                    }
                />
            </div>
            <div className='btn-grp flex justify-end gap-5 mt-5'>

                {props.roleObject.roleId > 0 ?
                    <>
                        <button className="update-btn btns" onClick={() => props.save()}> Update </button>
                        <button className="delete-btn btns" onClick={() => props.delete()}>Delete</button>
                    </>
                    :
                    <>
                        <button className="update-btn btns" onClick={() => props.save()}> Save </button>
                        <button className="delete-btn btns" onClick={() => props.setAddRoleModalOpen(false)}>Delete</button>
                    </>
                }


            </div>
        </ModalBasic>

    )
}

export default RoleModal